import { OutlinedDivider } from 'components/ui'

export function ProductDivider() {
  return (
    <div className="p-x-24 p-y-8">
      <OutlinedDivider />
    </div>
  )
}
